<template>
  <v-row justify="center">
    <v-col cols="8">
      <!-- Buscador -->
      <v-row justify="center">
        <v-col cols="10">
          <div class="mx-2">
            <producto-buscador-catalogo
              placeholderProp="Buscar productos del catálogo"
              :usarProductoEmpresa="usarProductoEmpresa"
              @process-buscador-producto="goToBuscador"
              @process-buscador-producto-select="goToBuscador"
              :showSuggest="false"
            />
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="productos_catalogo.length > 0">
        <v-col cols="10">
          <div class="text-h6">
            Estos productos coinciden con tu búsqueda. ¿Alguno es el tuyo?
          </div>
        </v-col>
      </v-row>

      <!-- Si hay productos -->
      <v-row class="mt-4" v-if="productos_catalogo.length > 0">
        <v-col>
          <v-divider></v-divider>
          <v-list two-line>
            <v-list-item
              v-for="producto in productos_catalogo"
              :key="producto.id"
              class="mb-2"
              @click="seleccionarProductoCatalogo(producto)"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ producto.descripcion }}
                  <span
                    ><v-chip
                      v-if="producto.ya_registrado"
                      label
                      small
                      color="green"
                      class="ml-2"
                      text-color="white"
                    >
                      Ya añadido
                    </v-chip></span
                  >
                </v-list-item-title>
                <v-list-item-subtitle>
                  <v-chip label small class="mr-2">
                    Categoría:
                    <span class="font-weight-bold ml-1">{{
                      producto.categoria || "Sin categoría"
                    }}</span>
                  </v-chip>
                  <v-chip label small>
                    Marca:
                    <span class="font-weight-bold ml-1">{{
                      producto.marca.nombre || "Sin marca"
                    }}</span>
                  </v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <!-- Si no hay productos -->
      <v-row  justify="center" v-else-if="busqueda_realizada" class="mt-6">
        <v-col cols="12" md="8">
          <v-card outlined class="pa-6 d-flex flex-column" color="#1e1e1e">
            <div class="d-flex align-center mb-4">
              <v-icon size="36" color="blue lighten-2" class="mr-3"
                >mdi-magnify-close</v-icon
              >
              <div>
                <h3 class="font-weight-medium mb-1" style="color: #ffffff">
                  No se encontraron productos
                </h3>
                <p class="text-subtitle-2 mb-0" style="color: #b0b0b0">
                  No se encontraron productos en el catálogo con esa
                  descripción.
                </p>
              </div>
            </div>

            <div class="d-flex align-center mt-4">
              <span class="text-subtitle-2" style="color: #b0b0b0">
                ¿Deseás registrar un nuevo producto?
              </span>
              <v-btn
              outlined
                small
                color="blue darken-2"
                class="ml-4"
                @click="registrarNuevoProducto"
              >
                Registrar producto
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script>
import ProductosAPI from "@/api/productos";
import ProductoBuscadorCatalogo from "@/components/producto/buscador/producto.buscador.catalogo.vue";

import { mapMutations, mapState, mapActions } from "vuex";
export default {
  name: "producto.buscador.automatico",
  components: { ProductoBuscadorCatalogo },
  props: {
    categorias: {
      type: Array,
      required: false,
      default: () => [],
    },
    usarProductoEmpresa: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholderProp: {
      type: String,
      required: false,
      default: "Buscar",
    },
  },
  data() {
    return {
      inputSearch: "alo",
      inputSelectProducto: null,
      isLoading: false,
      productos: [],
      borrando: false, //Bandera que se activa cuando presiona 'del'
      isFocused: false,
      productoCatalogo: null,
      busqueda_realizada: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    ...mapState("productos", [
      "paginacion_productos_catalogo",
      "productos_catalogo",
    ]),

    queryParams() {
      return this.$route.query || "";
    },
  },
  methods: {
    ...mapMutations("productos", [
      "SET_CANTIDAD_PRODUCTOS_CATALOGO",
      "SET_PAGE_PRODUCTOS_CATALOGO",
      "SET_PRODUCTOS_CATALOGO",
      "SET_LOADING_PRODUCTOS_CATALOGO",
    ]),
    ...mapActions("productos", ["get_productos_catalogo_for_params"]),
    registrarNuevoProducto() {
      this.$emit("set:productoCatalogo", null);
    },
    seleccionarProductoCatalogo(producto) {
      this.$emit("set:productoCatalogo", producto);
    },
    goToBuscador(search) {
      console.log(search);

      if (search == "") {
        this.$router.replace({ path: "productos" }).catch((e) => {});
        return;
      }
      this.busqueda_realizada = true;
      this.search = search;
      // if (search == this.$route.query.q) {
      //   return;
      // }
      this.SET_PAGE_PRODUCTOS_CATALOGO(1);
      var isBarcode = false;
      let isnum = /^\d+$/.test(search);

      if (isnum && search.length > 6) {
        isBarcode = true;
      }
      if (isBarcode) {
        this.add_query_url({ barcode: search });
      } else {
        this.add_query_url({ q: search });
      }

      this.fetchProductosCatalogo();
      // this.reload_search = !this.reload_search;
    },
    fetchProductosCatalogo() {
      this.SET_PAGE_PRODUCTOS_CATALOGO(1);
      var params = this.get_params_query();

      this.get_productos_catalogo_for_params(params);
    },
    get_text_transform(str) {
      if (typeof str === "string") {
        return str.match(/[^ ]+/g).join("-");
      } else {
        return str;
      }
    },
    add_query_url(value) {
      var querys = this.$route.query;

      for (const property in value) {
        var name = value[property];
        value[property] = this.get_text_transform(name);
        querys = Object.assign({}, querys, value);
      }
      this.$router.replace({ query: querys }).catch((error) => {
        if (error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    },
    get_params_query() {
      var array = [];
      var params = this.$route.params;
      if (params && params.categoria) {
        var object = {
          value: null,
          key: "",
        };
        object.value = params.categoria;
        object.key = "categoria";
        array.push(object);
      }

      var querys = this.$route.query;
      if (Object.keys(querys).length !== 0) {
        for (const property in querys) {
          var object = {
            nombre: null,
            key: "",
          };
          object.key = property;
          object.value = this.get_text_transform(querys[property]);
          array.push(object);
        }
      }
      array.push({ key: "global", value: true }); // Reemplaza "valor_global" con lo que necesites

      return array;
    },
  },
};
</script>

<style  scoped>
.v-input.custom-autocomplete {
  width: 680px;
}
.v-input.expanding-search {
  transition: max-width 0s;
}
.v-input::v-deep .v-input__control .v-input__slot {
  padding: 0 9px;
}

.v-input.expanding-search::v-deep .v-input__control.v-input__slot {
  cursor: pointer !important;
}

.v-input.expanding-search.closed {
  max-width: 40px;
}

.v-input.expanding-search.closed .v-input__slot {
  background: transparent !important;
}
</style>

